import LanguageEnum from "../../enums/language.enum";

export interface IEducatorReviewerProps {
  doolittleBaseMediaUrl: string;
  doolittleBaseApiUrl: string;
  activities: IActivity[];
  selectedIndex: number;
  setMinHeight?: boolean;
  lessonAttemptLanguage: string;
  getActivityToken: (
    pathId: number,
    pathVersion: number,
    takeId: string,
    isMasteryCheck: boolean,
    lessonAttemptId: string
  ) => Promise<ITokenViewerState>;
  itemEngineAuthorUri?: string;
  itemEngineItemsUri?: string;
}

export interface IEducatorPreviewerProps {
  lessonTitle: string;
  doolittleBaseMediaUrl: string;
  doolittleBaseApiUrl: string;
  activities: IActivity[];
  selectedIndex: number;
  setMinHeight?: boolean;
  spanishAvailable: boolean;
  previewLanguage: string;
  handleGetActivities: (language: LanguageEnum) => void;
  getActivityToken: (
    pathId: number,
    pathVersion: number,
    takeId: string,
    isMasteryCheck: boolean,
    lessonAttemptId: string
  ) => Promise<ITokenViewerState>;
  itemEngineAuthorUri?: string;
  itemEngineItemsUri?: string;
}

export interface IActivity {
  takeId: string;
  pathId: number;
  pathVersion: number;
  isMasteryCheck: boolean;
  title: string;
  lessonAttemptId: string;
  ilpId: string;
  type: string;
  isCompleted: boolean;
  score: number | null;
  lastAttemptedOn: string;
  timeSpentInSeconds?: number;
}

export interface IActivitySegment {
  segmentID: string;
  completed: boolean;
  correct?: boolean;
  inProgress: boolean;
  displayOrder: number;
}

export interface ITokenViewerState {
  status: ServiceStatusEnum;
  payload?: string;
  error?: Error;
}

export interface IActivitySegmentsState {
  response: IActivitySegment[];
}

export enum ServiceStatusEnum {
  INIT = "init",
  LOADING = "loading",
  LOADED = "loaded",
  ERROR = "error"
}

export const Languages = ["English", "Spanish"];

export const defaultDoolittleVersion = "1.3.560";
